export default "__VITE_ASSET__C_Qzj$v$__"